import api from './index'
import type { ApiResponse, CalendarEventItem } from '@/types'

interface FetchCalendarParams {
  startDate?: string
  endDate?: string
  sources?: string[]
  projectId?: string
}

export const getEvents = async (
  params: FetchCalendarParams = {},
): Promise<ApiResponse<{ events: CalendarEventItem[] }>> => {
  const response = await api.get('/calendar/events', { params })
  return response.data
}
